import { AuthUriFilter } from './authUri';
import { SpaceCamelCaseFilter } from './camelCaseToSpace';
import { ItemSizeFilter } from './itemSize';
import { TokenKeyValueFilter } from './tokenKeyValue';
import { TokenStringFilter } from './tokenString'
import { QueryStringUriFilter } from './queryStringUri';

export const filtersModule = angular
	.module('phoenix.filters',[
		'phoenix.services'
	])	
	.filter('pxAuthUri', AuthUriFilter)
	.filter('pxItemSize', ItemSizeFilter)
	.filter('pxSpaceCamelCase', SpaceCamelCaseFilter)
	.filter('pxTokenKeyValue', TokenKeyValueFilter)
	.filter('pxQueryString', QueryStringUriFilter)
	.filter('pxTokenString', TokenStringFilter);


// WEBPACK FOOTER //
// ./src/phoenix/filters/index.ts